import { Action } from "../../../actions/actions";
import { AuthActionTypes } from "../actions/actionTypes";

interface ServerSelectMenuOption {
    value: number | string;
    label: string;
}
const initialState : ServerSelectMenuOption[] = [];

export function usersPrivilegesReducer(state = initialState, action: Action) {
    switch (action.type) {
        case AuthActionTypes.GET_USERS_PRIVILEGES_SUCCESS:
            const privilege_array:ServerSelectMenuOption[] = action.payload.data.results.map((privilege,i) => {
               return {label: privilege.name, value: i, in:privilege.in};
            });
            return privilege_array;
        default:
            return state;
    }
}